import styled from "@emotion/styled"
import Dialog from "@mui/material/Dialog"

const StyledReview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px 22px 24px;
  border-radius: 24px;
  background: var(--cms-surface-primary);

  .heading-copy {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .page-title {
    margin: 0;
    font-size: 30px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .page-subtitle {
    margin: 0;
    font-size: 13px;
    color: var(--cms-text-secondary);
    font-weight: 500;
  }

  .page-surface {
    border: 1px solid var(--cms-border);
    border-radius: 18px;
    background: var(--cms-surface-secondary);
    box-shadow: var(--cms-shadow);
    padding: 14px;
  }

  .page-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    border: 1px dashed var(--cms-border);
    border-radius: 14px;
    font-size: 14px;
    font-weight: 600;
    color: var(--cms-text-secondary);
    background: var(--cms-surface-muted);
  }
`

const StyledReviewSearch = styled.div`
  display: flex;
  flex-direction: column;
`
const StyledReviewSearchBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  width: 100%;
  padding: 14px;
  border-radius: 14px;
  background: var(--cms-surface-muted);
  border: 1px solid var(--cms-border);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);

  .MuiTextField-root,
  .MuiFormControl-root {
    min-width: 170px;
  }

  .time-input {
    width: 162px;
  }

  .search-btn,
  .clear-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 10px;
    min-height: 40px;
    padding: 8px 16px;
  }

  .search-btn {
    box-shadow: 0 12px 24px rgba(29, 78, 216, 0.22);
  }
`

const StyledReviewResult = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: 12px;

  .pagination-section {
    display: flex;
    justify-content: flex-end;
  }

  .search-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    background: var(--cms-surface-muted);
    margin-bottom: 10px;
    padding: 10px 13px;
    font-size: 13px;
    color: var(--cms-text-primary);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.06);
  }

  .MuiTableContainer-root {
    border: 1px solid var(--cms-border);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  }

  .MuiTableCell-head {
    background: var(--cms-table-head-bg);
    color: var(--cms-text-primary);
    font-weight: 700;
    font-size: 12px;
    border-bottom: 1px solid var(--cms-border);
  }

  .MuiTableCell-body {
    font-size: 13px;
    color: var(--cms-text-primary);
    border-bottom: 1px solid var(--cms-border);
    vertical-align: top;
  }

  .status-cell {
    min-width: 120px;
  }

  .target-cell {
    min-width: 210px;
  }

  .comment-cell {
    max-width: 300px;
    white-space: pre-wrap;
    word-break: break-word;
  }

  .user-cell {
    min-width: 180px;
  }

  .action-btn {
    text-transform: none;
    font-weight: 700;
    border-radius: 9px;
    min-width: 140px;
  }

  .empty-row {
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    padding: 18px;
  }
`

const StyledReviewDlg = styled(Dialog)`
  .MuiPaper-root {
    width: min(760px, calc(100vw - 30px));
    min-height: 520px;
    border-radius: 18px;
    border: 1px solid var(--cms-border);
    background: var(--cms-dialog-bg);
    box-shadow: 0 24px 52px rgba(15, 23, 42, 0.2);
  }

  .MuiFormControl-root {
    margin: 0 0 16px;
    width: 100%;
  }

  .MuiDialogTitle-root {
    padding: 18px 22px 8px;
    font-size: 20px;
    font-weight: 800;
    color: var(--cms-text-primary);
    letter-spacing: -0.01em;
  }

  .MuiDialogContent-root {
    padding: 10px 22px 12px;
  }

  .MuiDialogActions-root {
    padding: 10px 22px 20px;
    gap: 10px;
  }
`

export {
  StyledReview,
  StyledReviewSearch,
  StyledReviewSearchBar,
  StyledReviewResult,
  StyledReviewDlg,
}
